
import React from "react";
import { IProfile } from "../../../../services";
import { i18nManager } from "../../../../i18n";

function Others() {

    const labels = i18nManager.Labels.dashboard.ploutous.others;

    return (<div className="charon-messages">
        <div className="management">
            <div className="others">
                {labels.sections.map((section) => (<a key={section.title} className="other" href={section.location}>
                    <i className={section.icon} />
                    <span className="t">{section.title}</span>
                    <span className="d">{section.desc}</span>
                </a>))}
            </div>
        </div>
    </div>);
}

export default Others;
